// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_NOTIFICATIONS_REQUEST,
  DELETE_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATION_REQUEST,
  UPDATE_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_RELEASE_REQUEST,
} from './actionTypes';
import {
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  deleteNotificationSuccess,
  deleteNotificationFailure,
  fetchNotificationSuccess,
  fetchNotificationFailure,
  updateNotificationSuccess,
  updateNotificationFailure,
  fetchNotificationsReleaseSuccess,
  fetchNotificationsReleaseFailure,
} from './actions';
import { deleteNotification, getAllNotifications, getAllNotificationsRelease, getNotification, updateNotification } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchNotificationsSaga() {
  try {
    const response = yield call(getAllNotifications);
    yield put(fetchNotificationsSuccess(response));
  } catch (error) {
    yield put(fetchNotificationsFailure(reduxSerializedError(error)));
  }
}

function* fetchNotificationsReleaseSaga() {
  try {
    const response = yield call(getAllNotificationsRelease);
    yield put(fetchNotificationsReleaseSuccess(response));
  } catch (error) {
    yield put(fetchNotificationsReleaseFailure(reduxSerializedError(error)));
  }
}

function* fetchNotificationSaga({ payload }) {
  try {
    const response = yield call(getNotification, payload);
    yield put(fetchNotificationSuccess(response));
  } catch (error) {
    yield put(fetchNotificationFailure(reduxSerializedError(error)));
  }
}

function* deleteNotificationsSaga({ payload }) {
  try {
    yield call(deleteNotification, payload);
    yield put(deleteNotificationSuccess(payload));
    yield call(fetchNotificationsSaga); // Refresh the notification list
  } catch (error) {
    yield put(deleteNotificationFailure(reduxSerializedError(error)));
  }
}

function* updateNotificationSaga({ payload }) {
  const { notification, navigate } = payload;
  try {
    yield call(updateNotification, notification);
    yield put(updateNotificationSuccess());
    yield call(fetchNotificationsSaga); // Refresh the notification list
  } catch (error) {
    yield put(updateNotificationFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
  yield takeEvery(FETCH_NOTIFICATIONS_RELEASE_REQUEST, fetchNotificationsReleaseSaga);
  yield takeEvery(FETCH_NOTIFICATION_REQUEST, fetchNotificationSaga);
  yield takeEvery(UPDATE_NOTIFICATIONS_REQUEST, updateNotificationSaga);
  yield takeEvery(DELETE_NOTIFICATIONS_REQUEST, deleteNotificationsSaga);
}
